/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import styles from 'styles';
import * as moment from 'moment';

import { getTimeContracts } from 'actions/contracts';
import { execute } from 'store/configureStore';
import { getLetter, updateLetter } from 'sagas/lettersNew';
import * as sagaAnnotations from 'sagas/annotations';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import ErrorBoundary from '../Cargo/ErrorBoundary';
import HtmlContent from '../HtmlContent';
import TextEditor from '../Cargo/Content/TextEditor';
import Attachments from 'components/Letters/Single/Attachments';
// import Trainings from 'components/Letters/Single/Gazetter/Trainings';
import AnnotationsEditor from '../Cargo/Content/AnnotationsEditor';
import AnnotationsList from '../Cargo/Content/AnnotationsList';
import UserSelector from 'components/Base/UserSelector';
import { removeGazetters, postGazetters } from 'actions/gazetters';
import { removeAnnotations } from 'actions/annotations';
import { getCargoTypes } from 'actions/cargoes/types';
import { addTcOrder, createTcOrders, updateTcOrderUser, removeLastTcOrder } from 'actions/tc/orders';
import { postRequestTC } from 'actions/tc/requests';
import TcOrderTable from './TcOrderTable';
import _ from 'lodash';
import { saveRequestsDataCreated } from 'sagas/orders';
import FailedToSent from '../../common/FailedToSent';
import api from 'services';
import ToSpamButton from '../../common/ToSpamButton';

class LetterTc extends React.Component {
    constructor(props) {
        super(props);

        if (localStorage.getItem(`settings-order-tc${props.objUser.user._id}`)) {
            this.initialState = JSON.parse(localStorage.getItem(`settings-order-tc${props.objUser.user._id}`));
        } else {
            this.initialState = { annotationsServer: 'mailparse.net', clarifiedServer: 'standart' };
            localStorage.setItem(`settings-order-tc${props.objUser.user._id}`, JSON.stringify(this.initialState));
        }

        this.state = {
            ...this.initialState,
            textLetter: '',
            typeAnnotations: 'annotate',
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
            updated: false,
            clientTc: undefined,
            openedAttachmentsDialog: false,

            selectedServer: 'mailparse.net',
            failedToSentOpen: false,
            isFormChanged: false,
            tcOrdersDuplicates: [],
        };
    }

    getLetterData = async (textEdit) => {
        try {
            const { data: letter } = await execute(getLetter, this.props.routeParams.id);

            letter.gazettersArr = [];
            letter.type = 'cargo';
            letter.fromTcOrders = true;

            if (textEdit) {
                letter.text = textEdit;
            }

            const annotationsResponse = await execute(
                sagaAnnotations.postAnnotations, 
                letter.text, 
                letter.type, 
                this.state.annotationsServer, 
                { 
                    emailId: letter._id,
                    subject: letter.subject,
                    date: moment(letter.date).format('DD-MM-YYYY'),
                },
            );

            if (annotationsResponse) {
                letter.gazettersArr = annotationsResponse.data.annotations;
                if (annotationsResponse.data.newclarified) {
                    letter.newclarified = annotationsResponse.data.newclarified;
                }
            }

            await execute(updateLetter, _.omit(letter, 'gazettersArr'), 'cargo', this.state.clarifiedServer);

            if (!this.props.tcOrders || this.props.tcOrders.length === 0) {
                this.props.addTcOrder();
            }
        } catch (error) {
            console.error(error);
        }
    }

    componentDidMount() {
        const { state } = this.props.location;

        this.props.getTimeContracts();
        this.props.getCargoTypes();

        if (state) {
            this.getLetterData(state.modifiedTextLetter);
        } else {
            this.getLetterData();
        }
    }

    updatePostGazetters = (textLetter) => {
        this.setState({
            textLetter,
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
            updated: true,
        }, async () => {
            await this.props.postGazetters(
                textLetter,
                {
                    emailId: this.props.letter._id,
                    subject: this.props.letter.subject,
                    date: moment(this.props.letter.date).format('DD-MM-YYYY'),
                },
            );
        });
    }

    toggleAttachmentsDialog = () => {
        this.setState({
            openedAttachmentsDialog: !this.state.openedAttachmentsDialog,
        });
    }

    changeAnnotationsServer = (e, i, value) => {
        this.initialState = {
            annotationsServer: value,
            clarifiedServer: this.state.clarifiedServer,
        };

        localStorage.setItem(`settings-order-tc${this.props.objUser.user._id}`, JSON.stringify(this.initialState));

        this.setState(this.initialState, () => { this.getLetterData(this.state.textLetter); });
    }

    changeClarifiedServer = (e, i, value) => {
        this.initialState = {
            annotationsServer: this.state.annotationsServer,
            clarifiedServer: value,
        };

        localStorage.setItem(`settings-order-tc${this.props.objUser.user._id}`, JSON.stringify(this.initialState));

        this.setState(this.initialState, () => { this.getLetterData(this.state.textLetter); });
    }

    removeOrderTable = () => {
        this.props.removeLastTcOrder();
    }

    clearOrderTable = () => {
        this.props.removeLastTcOrder();
        this.props.addTcOrder();
    }

    addOrderTable = () => {
        this.props.addTcOrder();
    }

    saveRequestsDataCreated = async (order) => {
        try {
            await execute(saveRequestsDataCreated, 'tc', order);
        } catch (error) {
            console.error(error);
        }
    };

    prepareTc = (tcToPrepare, letter) => {
        if (tcToPrepare.account) {
            if (tcToPrepare.account._id) {
                tcToPrepare.account = { _id: tcToPrepare.account._id };
            } else if (tcToPrepare.account.name) {
                tcToPrepare.account = { name: tcToPrepare.account.name };
            }
        }

        if (tcToPrepare.vesselRequirements.typeByPurpose) {
            tcToPrepare.vesselRequirements.typeByPurpose = tcToPrepare.vesselRequirements.typeByPurpose.toLowerCase();
        } else {
            tcToPrepare.vesselRequirements.typeByPurpose = undefined;
        }

        if (tcToPrepare.vesselRequirements.typeByConstruction) {
            tcToPrepare.vesselRequirements.typeByConstruction = tcToPrepare.vesselRequirements.typeByConstruction.toLowerCase();
        } else {
            tcToPrepare.vesselRequirements.typeByConstruction = undefined;
        }

        if (!tcToPrepare.vesselRequirements.typeBySpecialty) {
            tcToPrepare.vesselRequirements.typeBySpecialty = undefined;
        }

        if (tcToPrepare.vesselRequirements.iceClass) {
            tcToPrepare.vesselRequirements.iceClass = tcToPrepare.vesselRequirements.iceClass.toLowerCase();
        }

        if (tcToPrepare.vesselRequirements.registerClasses) {
            tcToPrepare.vesselRequirements.registerClasses = tcToPrepare.vesselRequirements.registerClasses.map(item => ({
                registerClass: item._id,
                iacsRegister: item.iacsRegister,
                excluded: item.excluded,
            }));
        }

        if (tcToPrepare.contract) {
            tcToPrepare.contractId = tcToPrepare.contract;
        }

        tcToPrepare.deliveryPlaces = tcToPrepare.deliveryPlaces.filter((p, i) => i === 0 || p.port._id);
        tcToPrepare.redeliveryPlaces = tcToPrepare.redeliveryPlaces.filter((p, i) => i === 0 || p.port._id);

        if (!tcToPrepare.readinessDate) {
            tcToPrepare.readinessDate = new Date();
        }

        if (!tcToPrepare.cancellingDate) {
            tcToPrepare.cancellingDate = new Date();
        }

        if (tcToPrepare.account && !tcToPrepare.account.name && !tcToPrepare.account._id) {
            delete tcToPrepare.account;
        }

        tcToPrepare.context = {
            companyId: (letter.context.companyId && letter.context.companyId._id) || undefined,
            userId: letter.context.userId ? letter.context.userId._id : undefined,
            kind: letter.context.kind,
            parser: letter.context.parser,
        };

        [tcToPrepare.cargo.included, tcToPrepare.cargo.excluded].forEach((cg) => {
            cg.forEach((item) => {
                if (item.cargoType && !item.cargoType.name) {
                    item.cargoType = null;
                }
            });
        });

        if (!tcToPrepare.vesselRequirements.dwtMin || !tcToPrepare.vesselRequirements.dwtMax) {
            const elements = document.getElementsByName('dwtMin');

            elements && elements[0] && elements[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
            return;
        }

        tcToPrepare.terms.user && tcToPrepare.terms.user.forEach((item) => {
            if (item.type) {
                item.value = `${item.type} ${item.value}`;
            }
        });

        if (tcToPrepare.vesselRequirements.gearV2) {
            tcToPrepare.vesselRequirements.gearV2.summary = tcToPrepare.vesselRequirements.gearV2.summary.filter(i => i.type);
            
            if (tcToPrepare.vesselRequirements.geared !== undefined && tcToPrepare.vesselRequirements.gearV2.summary.length === 0) {
                tcToPrepare.vesselRequirements.geared = false;
            }
        }

        if (tcToPrepare.vesselRequirements.grabV2) {
            tcToPrepare.vesselRequirements.grabV2.summary = tcToPrepare.vesselRequirements.grabV2.summary.filter(i => i.type);
        
            if (tcToPrepare.vesselRequirements.grabV2.summary.length === 0) {
                tcToPrepare.vesselRequirements.grabbed = false;
            }
        }

        if (!tcToPrepare.mailId) {
            tcToPrepare.mailId = letter._id;
        }

        if (letter.realUserEmail) {
            tcToPrepare.realUserEmail = letter.realUserEmail;
        }

        return tcToPrepare;
    };

    sendRequestTc = () => {
        const normalizedTc = _.cloneDeep(this.props.tcOrders);
        const { letter } = this.props;

        const errored = document.getElementsByClassName('hasValidationError')[0];

        if (errored) {
            errored.scrollIntoView({ behavior: 'smooth' });
            return;
        }

        this.setState({
            isFormChanged: false,
            tcOrdersDuplicates: _.cloneDeep(this.props.tcOrders),
        });

        normalizedTc.forEach((tc, index) => {
            const preparedTc = this.prepareTc(tc, letter);

            this.saveRequestsDataCreated(preparedTc);

            this.props.postRequestTC(preparedTc, index);
        });
    }

    handleClientChange = (value) => {
        this.setState({ clientTc: value });
    }

    toggleFailedToSentOpen = () => {
        this.setState({
            failedToSentOpen: !this.state.failedToSentOpen,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps.tcOrders, this.state.tcOrdersDuplicates)) {
            if (this.state.tcOrdersDuplicates.length) {
                this.setState({ isFormChanged: true });
            }
        } else {
            this.setState({ isFormChanged: false });
        }
    }

    sendRequestTcFromSent = async (failedTwinLetterData) => {
        const normalizedTc = _.cloneDeep(this.props.tcOrders);
        const { letter } = this.props;

        const results = [];

        for (const [index, tc] of Object.entries(normalizedTc)) {
            const preparedTc = this.prepareTc(tc, letter);

            if (failedTwinLetterData.context.kind === 'broker') {
                preparedTc.realUserEmail = failedTwinLetterData.realUserEmail;
                preparedTc.mailId = failedTwinLetterData._id;
                preparedTc.context = failedTwinLetterData.context;
            }

            const response = await api.postRequestTc(preparedTc);

            if (response.data && (response.errors && !response.errors.length)) {
                results.push({
                    ...response.data,
                    status: 'success',
                });
                await api.sendRefNumber(failedTwinLetterData._id, {
                    refNo: response.data.refNo, 
                    requestId: response.data.id || response.data._id,
                });
            } else {
                results.push({
                    status: 'error',
                    message: _.get(response, 'errors[0].message') ||
                         _.get(response, 'errors[0].messages[0]'),
                });
            }
        }

        return results;
    };

    render() {
        const {
            annotationsServer, clarifiedServer, textLetter, updated, clientTc, openedAttachmentsDialog, 
            failedToSentOpen,
        } = this.state;
        const {
            letter, routeParams, router, objUser, user, tcOrders, location, 
        } = this.props;

        let modifiedTextLetter;
        let initialTextLetter;

        if (location.state) {
            modifiedTextLetter = location.state.modifiedTextLetter;
            initialTextLetter = location.state.initialTextLetter;
        }

        const hasCargoOrder = letter && letter.clarified && letter.clarified.find(c => c.typeCategory.includes('request'));

        return (
            <div id='single-letter-cargo' className='single-letter'>
                <div className='content' style={{ width: '60vw' }}>
                    <div className='management'>
                        <div className='management-children'>
                            <RaisedButton
                                className='btn'
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '10px 10px 10px 0' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                label='Gazetteer'
                                containerElement={<Link to={`/${routeParams.id}`} />}
                                primary
                            />

                            <ErrorBoundary>
                                <HtmlContent letter={letter} />
                            </ErrorBoundary>

                            <TextEditor 
                                textLetter={modifiedTextLetter || textLetter || letter.text}
                                originalText={initialTextLetter || letter.text}
                                removeGazetters={this.props.removeGazetters}
                                removeAnnotations={this.props.removeAnnotations}
                                getLetterData={this.getLetterData}
                                updatePostGazetters={this.updatePostGazetters}
                            />

                            <Attachments 
                                openedAttachmentsDialog={openedAttachmentsDialog}
                                toggleAttachmentsDialog={this.toggleAttachmentsDialog}
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '10px 10px 10px -10px' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                className='btn'
                                attachments={letter.attachments}
                            />

                            <SelectField
                                floatingLabelText='Annotations server'
                                className='btn'
                                style={{ width: '155px' }}
                                value={annotationsServer}
                                onChange={this.changeAnnotationsServer}
                            >
                                <MenuItem value='mailparse.net' primaryText='mailparse.net' />
                                <MenuItem value='s4.anotatr.com' primaryText='s4.anotatr.com' />
                                <MenuItem value='nata.im' primaryText='nata.im' />
                                <MenuItem value='polza' primaryText='polza' />
                                <MenuItem value='localhost' primaryText='localhost' />
                            </SelectField>

                            <SelectField
                                floatingLabelText='Clarified server'
                                className='btn'
                                style={{ width: '110px' }}
                                value={clarifiedServer}
                                onChange={this.changeClarifiedServer}
                                autoWidth
                            >
                                <MenuItem value='standart' primaryText='api' />
                                <MenuItem value='localhost:7775' primaryText='localhost' />
                                <MenuItem value='s4.anotatr.com:7777' primaryText='s4.anotatr.com' />
                            </SelectField>
                            <br />
                            {/* <Trainings letter={this.props.letter} /> */}
                            <ToSpamButton
                                letterId={letter._id}
                                onSuccess={() => {
                                    this.getLetterData();
                                }}
                                disabled={letter.type === 'spam'}
                            />
                            <FailedToSent
                                open={failedToSentOpen}
                                failedTwinsList={letter.failedTwinsByTextHash || []}
                                handleToggleDialog={this.toggleFailedToSentOpen}
                                disabled={this.state.isFormChanged || !this.state.tcOrdersDuplicates.length}
                                sendRequest={this.sendRequestTcFromSent}
                            />
                        </div>

                        <div style={{ width: '150px' }} className='subject'>SUBJECT: { letter.subject } </div>
                        <div className='subject' style={{ width: '70px' }}>refNo: { letter.refNo } </div>
                    </div>

                    {
                        updated ?
                            (
                                <ErrorBoundary>
                                    <AnnotationsEditor letterText={textLetter || letter.text} />
                                </ErrorBoundary>
                            )
                            :
                            (
                                <ErrorBoundary>
                                    <AnnotationsEditor letterText={modifiedTextLetter || letter.text} />
                                </ErrorBoundary>
                            )
                    }

                    <ErrorBoundary>
                        <AnnotationsList />
                    </ErrorBoundary>
                </div>
                <div className='sidebar' style={{ width: '40vw', height: 'calc(100vh - 100px)' }}>
                    <h1>TC requests {tcOrders.length}<span style={{ color: 'red' }}>{ hasCargoOrder && ' Has cargo requests' }</span></h1>

                    <ErrorBoundary>
                        {
                            tcOrders.map((tcOrder, key) => (
                                <TcOrderTable
                                    numberOrderTable={key}
                                    tcOrder={tcOrder}
                                    key={['tcOrder', key].join('_')}
                                />
                            ))
                        }
                    </ErrorBoundary>

                    <ErrorBoundary>
                        <UserSelector 
                            handleClientChange={(_e, _i, value) => this.handleClientChange(value)}
                            client={clientTc}
                            user={user}
                            letter={letter}
                            onUserUpdate={this.props.updateTcOrderUser}
                        />
                    </ErrorBoundary>

                    <ul className='controller-orders' style={{ width: '40vw' }}>
                        <li>
                            <FlatButton style={styles.btnNewOrders} onClick={this.addOrderTable} label='Add' />
                        </li>
                        <li>
                            <FlatButton style={styles.btnNewOrders} onClick={this.removeOrderTable} label='Remove' />
                        </li>
                        <li>
                            <FlatButton style={styles.btnNewOrders} onClick={this.clearOrderTable} label='Clear' />
                        </li>
                        <li>
                            <FlatButton style={styles.btnNewOrders} onClick={this.sendRequestTc} label='Send' />
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default connect(
    ({
        user: objUser, tcOrders: { items: tcOrders, user }, user: { isLogged }, letter, annotations: { items: annotations }, 
    }) => ({
        objUser,
        user,
        tcOrders,
        isLogged,
        letter,
        annotations,
    }),
    dispatch => bindActionCreators({
        updateTcOrderUser,
        removeLastTcOrder,
        postGazetters,
        getCargoTypes,
        addTcOrder,
        createTcOrders,
        postRequestTC,
        getTimeContracts,
        removeGazetters,
        removeAnnotations,
    }, dispatch),
)(LetterTc);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/TC/LetterTc.jsx